<template>
  <div class="container-fluid">
    <div
      class="col-12 text-center"
      style="color: darkgrey; margin-top: 25%; opacity: 0.4;">
      <h1>
        eStore Admin Panel
      </h1>
    </div>
  </div>
</template>

